import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-50" }
const _hoisted_2 = { class: "mx-auto w-full max-w-5xl px-4 py-6 sm:px-6" }

import { useStore } from "vuex";
import { useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'LayoutExternal',
  setup(__props) {

const store = useStore();
const router = useRouter();

const logout = async () => {
  await store.dispatch("logout");
  router.push("/login");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", { class: "flex items-center justify-between border-b border-gray-200 bg-white px-4 py-3 sm:px-6" }, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex items-center gap-3 min-w-0" }, [
        _createElementVNode("span", { class: "text-lg font-semibold text-gray-900 truncate" }, "Kandidatpresentation")
      ], -1)),
      _createElementVNode("button", {
        type: "button",
        class: "rounded-lg border border-gray-300 px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-100",
        onClick: logout
      }, " Logga ut ")
    ]),
    _createElementVNode("main", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})